<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../../../components/widgets/loader";
import Forms from "../../../mixins/Forms";
import Dates from "../../../mixins/Dates";
import NotificationCard from "./Index/NotificationCard";

let _ = require('lodash');

import axios from 'axios';

/**
 * View ticket component
 */
export default {
  page: {
    title: "All Notifications",
    meta: [{name: "description", content: appConfig.description}]
  },
  mixins: [Forms, Dates],
  components: {Layout, PageHeader, Loader, NotificationCard},
  data() {
    return {
      title: "All Notifications",
      items: [
        {
          text: "Notifications",
          href: "#"
        },
        {
          text: "All Notifications",
          active: true
        }
      ],

      serverErrors: [],
      isLoading: false,
      notifications: null,

      statusOptions: [
        {
          label: 'Show all',
          value: 'all'
        },
        {
          label: 'Unread',
          value: 'unread'
        },
        {
          label: 'Read',
          value: 'read'
        }
      ],

      filters: {
        results_per_page: 30,
        status: 'all'
      }
    };
  },
  computed: {
    notificationResults() {
      if (this.notifications) {
        return this.notifications.data;
      }
      return [];
    }
  },
  methods: {
    determineSearchParams(page) {
      let params = {
        page: page,
        results_per_page: this.filters.results_per_page
      };

      if (this.filters.status !== null) {
        params['status'] = this.filters.status;
      }

      return params;
    },

    loadNotifications: _.debounce(function (page = 1) {
      let vm = this;
      vm.serverErrors = [];
      vm.isLoading = true;
      axios.post(API_BASE + '/notifications/search', vm.determineSearchParams(page)).then(r => {
        vm.notifications = r.data;
        vm.isLoading = false;
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setErrors(e);
      });
    }),

    setup() {
      this.loadNotifications();
    }
  },
  watch: {
    '$route': 'setup',
    filters: {
      handler: function () {
        this.loadNotifications();
      },
      deep: true
    }
  },
  created() {
    this.setup();
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <errors :error-list="serverErrors"></errors>

    <div class="row">
      <div class="col-lg-9">
        <!-- Is Loading -->
        <div v-if="isLoading" class="card">
          <div class="card-body text-center">
            <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
          </div>
        </div>
        <!-- / Is Loading -->

        <!-- Cards -->
        <div v-if="!isLoading" class="card-results-wrapper">
          <notification-card v-for="notification in notificationResults" :key="notification.id"
                             :notification="notification"></notification-card>
          <div class="card" v-if="notificationResults.length === 0">
            <div class="card-body">
              <b class="text-danger">No results</b>
            </div>
          </div>
        </div>

        <pagination v-if="!(isLoading) && notifications" :data="notifications" :limit="8"
                    @pagination-change-page="loadNotifications"></pagination>
      </div>
      <div class="col-lg-3">
        <div class="card">
          <div class="card-body p-4">
            <!-- Results per page -->
            <div class="form-group mb-3">
              <label for="results_per_page">Results To Show</label>
              <v-select v-model="filters.results_per_page" :clearable="false"
                        :options="[10,20,30,40,50,60,70,80,90,100]"></v-select>
            </div>
            <!-- / Results per page -->

            <!-- Status -->
            <div class="form-group mb-3">
              <label for="status">Status</label>
              <v-select v-model="filters.status" label="label" placeholder="Show all"
                        :reduce="option => option.value"
                        :options="statusOptions"></v-select>
            </div>
            <!-- / Status -->
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.main-content {
  overflow: visible;
}
</style>
